<template>
     <p-button 
    rounded
    v-if="enable"
    style="width:48px;"
    icon="pi pi-times-circle" @click="globalFeedBackStart()" />
    <p-button 
    rounded
    v-if="enable"
    style="width:48px;"
    icon="pi pi-info-circle" @click="dialogFlag = true" />
    <p-button 
    rounded
    v-if="enable"
    style="width:48px;"
    icon="pi pi-check-circle" @click="globalFeedBackStart('APPROVE')"  />
    <p-dialog modal style="margin: 10px" header="Remarks" v-model:visible="dialogFlag">
      <div style="min-width:600px">
        <div class="p-fluid p-grid p-col-12 p-formgrid">
          <div class="p-field p-col-12">
            <p-textarea
               v-model.trim="remarks"
              type="text"
              placeholder="Enter remarks"
             />
           </div>
          <div class="p-field p-col-12 p-md-6 p-field-btn">
              <p-button 
                label="Cancel" 
                icon="pi pi-times-circle" @click="dialogFlag = false" class="p-button"  />
          </div>
          <div class="p-field p-col-12 p-md-6 p-field-btn">
              <p-button 
                label="Request Information" 
                icon="pi pi-check-circle" @click="globalFeedBackStart('REQUEST')"  class="p-button"  />
          </div>
        </div>
      </div>
    </p-dialog>
</template>
  
  <script lang="ts">
  import { base } from "@/misc/base";
  import { Options } from "vue-class-component";
  
  @Options({
    props: {
      selection: Array,
      resource : String
    },
    emits: ['close']
  })
  export default class BulkApproval extends base {
    selection!: any[];
    resource!: string;
    dialogFlag = false;
    remarks! : string;
    enable = false

    mounted(){
      const service = this.store.state.simforce

      service.get(
        `/approve/can_evaluate/${this.resource}`,
      )
      .then(res => {
          this.enable = true
      })
      .catch(e => {
        console.log(e)
      })
    }

    successFeedBack(){
        // Use this.toast instead of this.$toast to avoid Vue warnings
        this.toast.add({
          severity: "success",
          summary: `Feedback sent`,
          detail: `Resource updated!`,
          life: 5000,
        });
        this.$emit("close")
      
      }

      errorFeedBack(e : any){
        let err = e.response?.data || { error: 'Unknown error occurred' }
        // Use this.toast instead of this.$toast to avoid Vue warnings
        this.toast.add({
          severity: "error",
          summary: "Error recording feedback",
          detail: err.err ? err.err : err.error,
          life: 5000,
        });
      }

      async globalFeedBackStart(m = "REJECT"){

        let req = {
          information: this.remarks,
          records: [] as any,
          approve : m == "APPROVE",
        } as any

        if (m == "REJECT")
            req.information = null

        for(let r of this.selection){

            if (!this.remarks?.length && !r.deleted){
             // if(r.enabled && m == "APPROVE")
             //     continue
              
              if(!r.enabled && m != "APPROVE")
                  continue
            }

            req.records.push(r._id)
        }

        try {

          const service = this.store.state.simforce

          await service.post(
            `/approve/batch/${m}`,
            req,
          )
          
          this.successFeedBack()
          
        } catch(e){
          this.errorFeedBack(e)
        }

        this.$emit('close')

      }
      
  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
    .p-button {
      margin-left:10px;
    }
    

    .p-grid {
        background:#fff;
    }

    .p-button.gr {
        margin-right:10px;
        width:2.357rem !important;
    }

    .p-md-4 {
      padding:5px !important;
    }

  </style>
  